import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { makeStyles } from '@mui/styles';
import { Skeleton } from '@mui/material';
import Pagination from './Pagination';
import NoDataAvailable from './_dashboard/smartlock/NoDataAvailable';

const useStyles = makeStyles({
  tableCell: {
    textTransform: 'capitalize'
  }
});

export default function CollapsibleTable({
  deviceTrip,
  loader,
  limit,
  pageNumber,
  handlePageChange,
  handleDataPerPage,
  totalCount
}) {
  const classes = useStyles();
  const [openRow, setOpenRow] = useState(null);

  const handleToggle = (id) => {
    setOpenRow((prevOpenRow) => (prevOpenRow === id ? null : id));
  };

  return (
    <TableContainer component={Paper} sx={{ backgroundColor: '#FFFFFF' }}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell align="left" sx={{ fontWeight: 'bold' }}>
              Trip ID
            </TableCell>
            <TableCell align="left" sx={{ fontWeight: 'bold' }}>
              Trip Status
            </TableCell>
            <TableCell align="left" sx={{ fontWeight: 'bold' }}>
              Route
            </TableCell>
            <TableCell align="left" sx={{ fontWeight: 'bold' }}>
              Duration
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loader && (
            <TableRow>
              <TableCell colSpan={10}>
                <Skeleton variant="rectangular" height={30} />
              </TableCell>
            </TableRow>
          )}
          {!loader && deviceTrip?.length === 0 && (
            <TableRow>
              <TableCell colSpan={10}>
                <NoDataAvailable />
              </TableCell>
            </TableRow>
          )}
          {!loader &&
            deviceTrip?.length > 0 &&
            deviceTrip?.map((item) => (
              <React.Fragment key={item?.id}>
                <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                  <TableCell component="th" scope="row" align="left" className={classes.tableCell}>
                    {item?.name}
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    {item?.status}
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    {item?.route?.name}
                  </TableCell>
                  <TableCell align="left" className={classes.tableCell}>
                    20.03.23- 24.05.23
                  </TableCell>
                  <TableCell>
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => handleToggle(item.id)}
                    >
                      {openRow === item.id ? (
                        <KeyboardArrowUpIcon sx={{ color: '#000000' }} />
                      ) : (
                        <KeyboardArrowDownIcon sx={{ color: '#000000' }} />
                      )}
                    </IconButton>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: '0' }} colSpan={6}>
                    <Collapse in={openRow === item?.id} timeout="auto" unmountOnExit>
                      <Box>
                        <Table size="small" aria-label="purchases">
                          <TableBody>
                            <TableRow>
                              <TableCell component="th" scope="row" align="left">
                                {item?.vehicle?.name}
                              </TableCell>
                              <TableCell align="left">{item?.vehicle?.registrationNo}</TableCell>
                              <TableCell align="left">{item?.driverName}</TableCell>
                              <TableCell align="left">{item?.driverPhone}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          {!loader && deviceTrip?.length !== 0 && (
            <TableRow>
              <TableCell colSpan={10}>
                <Pagination
                  pageNumber={pageNumber}
                  limit={limit}
                  handleChangePage={handlePageChange}
                  handleChangeRowsPerPage={handleDataPerPage}
                  pageCount={totalCount}
                />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
